<template>
    <div v-if="data.length" class="gallery">
        <div v-for="pictures in data" :key="pictures.id" class="gallery__column">
            <Picture v-for="pic in pictures.images" :key="pic._id" :picture="pic" />
        </div>
      </div>
</template>

<script>
import Picture from '../pictures/Picture';

import {splitPictureGallery} from '@/composables/pictures/displayGallery';
import { useStore } from 'vuex';
import { ref, watch } from 'vue';

import {displaySize} from '@/composables/utils/displaySize.js'


export default {
    components: {Picture},
    props:['gallery'],
    setup(props){
        const store = useStore();
        
         const screen = displaySize()
         let rows = 3;
        if( screen === 'phone'){
            rows = 1
        }else if(screen === 'tablet'){
            rows = 2
        }
        console.log(window.screen.width, screen, rows);

        const data = ref(props.gallery.length ? splitPictureGallery(props.gallery, rows) : []);

        // store in vuex for zoomed navigation
        store.state.gallery = props.gallery;

        watch(props, (newVal, oldVal) => {
            data.value = splitPictureGallery(newVal.gallery,rows);

            store.state.gallery = newVal.gallery;
        })



        return {data};
    }
}
</script>

<style lang="scss">
@import '@/style/main';
.gallery{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 4rem;
    
    &__column{
        width: 100%;
        height: auto;
        &:not(:last-child) {
            margin-right: 2rem;
            @include respond(phone) {
                margin-right: 0;
            }
        }
    }
}
</style>